export default "/images/bac725d98545cdf09f03cdb751a76c5a.avif";